// Leadership for Berkshire Investment Group Inc.
// Source: §18.1 of the strategic plan. All positions are filled.

export const leadership = {
  groups: [
    {
      key: 'group',
      label: 'Group Leadership',
      blurb: 'The senior executive committee responsible for group strategy, capital allocation, risk, finance and governance.',
      members: [
        { role: 'Founder & Group Chief Executive',                   focus: 'Vision, strategy, capital and external relationships' },
        { role: 'Group President & Chief Operating Officer',         focus: 'Operating performance across all platforms and regions' },
        { role: 'Group Chief Investment Officer',                    focus: 'Capital allocation, portfolio construction and investment discipline' },
        { role: 'Group Chief Financial Officer',                     focus: 'Treasury, capital markets, accounting, planning and reporting' },
        { role: 'Group Chief Risk Officer',                          focus: 'Sovereign, currency, counterparty and operational risk' },
        { role: 'Group General Counsel & Chief Compliance Officer',  focus: 'Legal, regulatory, FCPA, sanctions and governance' },
      ],
    },
    {
      key: 'platforms',
      label: 'Operating-Platform CEOs',
      blurb: 'Chief executives running BIG\'s permanent-capital operating platforms across capital markets, energy, minerals, infrastructure and digital.',
      members: [
        { role: 'Chief Executive · Rise Capital Group',     focus: 'Third-party fund management, private credit & infrastructure vehicles' },
        { role: 'Chief Executive · BIG Capital',            focus: 'Private credit, project finance, trade finance, structured credit' },
        { role: 'Chief Executive · BIG Energy',             focus: 'Power generation, transmission, gas-to-power, storage' },
        { role: 'Chief Executive · BIG Critical Minerals',  focus: 'Mining, processing, royalties, streaming and offtake' },
        { role: 'Chief Executive · BIG Infrastructure',     focus: 'Ports, rail, logistics corridors and trade infrastructure' },
        { role: 'Chief Executive · BIG Digital',            focus: 'Data centres, fibre, cloud, AI compute and cybersecurity' },
      ],
    },
    {
      key: 'crosscutting',
      label: 'Cross-Cutting Leadership',
      blurb: 'Senior leadership for the operating systems and strategic relationships that span every platform.',
      members: [
        { role: 'Chief Technology & AI Officer',  focus: 'Berkshire AI, OnePass, data, cloud and group technology' },
        { role: 'Head of Sovereign Partnerships', focus: 'Government engagement, PPP frameworks and national programmes' },
      ],
    },
  ],
  staffing: [
    { stage: 'Year 1 staffing',  size: '35 – 50 professionals',   detail: 'Investment, project development, capital raising, legal, risk, finance, engineering, government engagement, technology and communications.' },
    { stage: 'By Year 3 staffing', size: '125 – 175 professionals', detail: 'Corporate and development professionals, excluding operating-asset employees at portfolio companies.' },
  ],
  hubs: [
    { city: 'United States',                  role: 'Capital, corporations & government relationships' },
    { city: 'Dubai / Abu Dhabi',              role: 'Global capital and group coordination' },
    { city: 'Nairobi',                        role: 'East Africa hub' },
    { city: 'Johannesburg',                   role: 'Southern Africa hub' },
    { city: 'Accra / Abidjan',                role: 'West Africa hub' },
  ],
  committees: [
    'Investment Committee',
    'Audit & Risk Committee',
    'Governance & Nominations Committee',
    'Remuneration Committee',
    'Sustainability & Community Committee',
    'Technology, Cybersecurity & Data Committee',
    'Capital Allocation Committee',
  ],
};
